import { FC } from 'react';
import CheckoutSummaryCartProducts from '../CheckoutSummaryCartProducts/CheckoutSummaryCartProducts ';
import CustomerDetailsTab from '../CustomerDetailsTab/CustomerDetailsTab';

const CheckoutSummaryTab: FC = (): JSX.Element => {
  return (
    <div className="d-flex flex-column flex-1 full-width">
      <CustomerDetailsTab />
      <CheckoutSummaryCartProducts />
    </div>
  );
};

export default CheckoutSummaryTab;
